import styledBreakpoint from '@humblebee/styled-components-breakpoint';

// Devices breakpoints
const mobileBreakpoint = 500;
const tabletBreakpoint = 768;
const desktopBreakpoint = 1100;
const largeDesktopBreakpoint = 1650;
const xLargeDesktopBreakpoint = 1400;
const wideDesktopBreakpoint = 1980;


const media = styledBreakpoint({
  mobile: mobileBreakpoint,
  tablet: tabletBreakpoint,
  desktop: desktopBreakpoint,
  largeDesktop: largeDesktopBreakpoint,
  xLargeDesktop: xLargeDesktopBreakpoint,
});

/* How to use media queries:

${media.desktop`
  flex-direction:row;
`};

*/


// Check if device width is less than desktop breakpoint


const isOnMobile = () => {
  const query = global.window.matchMedia(
    `(max-width: ${desktopBreakpoint - 1}px)`,
  );

  return query.matches;
};

const isOnTablet = () => {
  const query = global.window.matchMedia(
    `(max-width: ${tabletBreakpoint - 1}px)`,
  );

  return query.matches;
};


export { isOnMobile, isOnTablet, media, mobileBreakpoint, desktopBreakpoint, tabletBreakpoint, largeDesktopBreakpoint, wideDesktopBreakpoint };



// WEBPACK FOOTER //
// ./src/common/responsive.js